import { render, staticRenderFns } from "./ReportCenterPage.vue?vue&type=template&id=47df3acc&"
import script from "./ReportCenterPage.vue?vue&type=script&lang=js&"
export * from "./ReportCenterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports